module.exports = __webpack_public_path__ + "static/media/6pic.a76d5f2e.jpg";